<template>
  <div class="login">
    <div class="login-logo">
      <el-image :src="imageUrl" class="logo-image"></el-image>
    </div>
    <div class="login-input">
      <div class="login-input-txt">登录您的账号</div>
      <el-form
        class="login-form"
        ref="LoginForm"
        :model="loginForm"
        :rules="loginFormRules"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="输入您的用户名"
            id="username"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            :type="inputType"
            v-model="loginForm.password"
            placeholder="输入您的密码"
            id="password"
          >
            <el-image
              :src="showPassword ? showPasswordImage : hidePasswordImage"
              slot="suffix"
              class="pass-image"
              @click="changeInputType"
            >
            </el-image>
          </el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="isNeedCode">
          <el-input
            v-model="loginForm.captcha"
            placeholder="输入图形验证码"
            id="code"
            maxLength="8"
          >
            <el-image
              v-loading="loadingCode"
              :src="codeImage"
              slot="suffix"
              class="code-image"
              @click="getLoginId"
            >
            </el-image>
          </el-input>
        </el-form-item>
        <el-form-item prop="enabled">
          <div class="read-box">
            <el-checkbox v-model="loginForm.enabled"></el-checkbox>
            <span class="read-txt"
            >我已阅读并同意<span

              class="read-form"
            ><span  @click.stop="readYHXY">用户协议</span>、<span  @click.stop="readYSZC">隐私政策</span></span
            ></span
            >
          </div>
        </el-form-item>
        <el-button
          @click="login"
          :loading="loading"
          type="primary"
          class="btn_login"
          >{{ loading ? "登录中..." : "登录" }}</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCode, getUserInfo, haveCode, login, getRandom } from "./api";
import { docCookies } from "@/common/js/CookieUtil";
import { debounce } from "lodash";
import md5 from "js-md5";
import { getDictPageAll } from "@/views/commonApi";
import router from "@/router";
export default {
  components: {},
  data() {
    return {
      loadingCode: false,
      isNeedCode: false,
      inputType: "password",
      showPassword: false,
      codeImage: "",
      showPasswordImage: require("@/assets/img/show-password.png"),
      hidePasswordImage: require("@/assets/img/hide-password.png"),
      imageUrl: require("@/assets/img/logo.png"),
      loading: false,
      loginForm: {
        // username: "wyq222222",
        // password: "wyq544184791_",
        // username: "ls",
        // password: "loans123",
        username: "",
        password: "",
        loginId: "",
        captcha: "",
        enabled: "",
      },
      loginFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        enabled: [
          { required: true, message: "请阅读并同意协议", trigger: "change" },
        ],
      },
    };
  },

  created() {
    localStorage.clear();

    this.enterLogin();
    this.needCode();
    this.login = debounce(this.login, 100, {
      leading: true,
      trailing: false,
    });
  },
  mounted() {
  },
  methods: {

    readYHXY() {
     // this.$router.push({
     //   name: 'YSXY'
     // })
      window.open('/yhxy.html', '_blank')
    },
    readYSZC() {
      // this.$router.push({
      //   name: 'YSZC'
      // })
      window.open('/yszc.html', '_blank')
    },
    // 判断是否需要验证码登录
    needCode() {
      haveCode().then((res) => {
        if (res.code === 200) {
          this.isNeedCode = res.data;
          if (this.isNeedCode) {
            this.getLoginId();
          }
        }
      });
    },
    changeInputType() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    changeCode() {
      this.loadingCode = true;
      getCode(this.loginForm.loginId)
        .then((res) => {
          this.loginForm.captcha = "";
          this.loadingCode = false;
          if (res.code === 200) {
            this.codeImage = "data:image/png;base64," + res.data.captcha;
          }
        })
        .catch((err) => {
          this.loadingCode = false;
          this.$message.error("获取验证码失败");
        });
    },

    getUserData() {
      getUserInfo()
        .then((res) => {
          if (res.code === 200) {
            console.log("userInfo", res.data);
            localStorage.setItem("u", JSON.stringify(res.data));
            localStorage.setItem("menus", JSON.stringify(res.data.menus));

            if (res.data.menus && res.data.menus.length > 0) {
              if (
                res.data.menus[0].children &&
                res.data.menus[0].children.length > 0
              ) {
                this.$router.replace({
                  path: res.data.menus[0].children[0].menuLink,
                });
              } else {
                this.$router.replace({
                  path: res.data.menus[0].menuLink,
                });
              }
            } else {
              this.$message.warning('登录失败，请联系管理员配置菜单')
            }
          }
        })
        .catch((err) => {});
    },
    loginSuccess(menuData) {
      let routes = [];
      let sycRoutes = [];
      // 将菜单数据转换为路由格式
      menuData.forEach((item) => {
        routes.push({
          name: item.menuCode,
          path: item.menuLink,
          component: () => import(`@/views/${item.menuLink}.vue`),
          meta: {
            title: `${item.menuName}`,
          },
        });
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            routes.push({
              name: item2.menuCode,
              path: item2.menuLink,
              component: () => import(`@/views/${item2.menuLink}.vue`),
              meta: {
                title: `${item2.menuName}`,
              },
            });
          });
        }
      });
      sycRoutes.push({
        path: "/",
        component: () => import("@/Layout/index.vue"),
        children: routes,
      });
      let newRoutes = sycRoutes.concat(this.baseRoutes);
      console.log("newRoutes", newRoutes);
      // 使用addRoutes添加路由
      router.addRoute(newRoutes);
      setTimeout(() => {
        if (menuData[0].children && menuData[0].children.length > 0) {
          this.$router.replace({
            path: menuData[0].children[0].menuLink,
          });
        } else {
          this.$router.replace({
            path: menuData.menuLink,
          });
        }
      }, 500);
    },
    getLoginId() {
      this.loadingCode = true;
      getRandom()
        .then((res) => {
          if (res.code === 200) {
            this.loginForm.loginId = res.data;
            this.changeCode();
          }
        })
        .catch((err) => {
          this.loadingCode = false;
        });
    },

    login() {
      this.$refs["LoginForm"].validate(async (validate) => {
        if (!validate) return;
        this.loading = true;
        this.$store
          .dispatch("login", this.loginForm)
          .then((res) => {
            this.$store
              .dispatch("getUserData")
              .then((response) => {
                this.loading = false;
                localStorage.setItem("u", JSON.stringify(response));
                localStorage.setItem("menus", JSON.stringify(response.menus));
                localStorage.setItem("currentRoleId", response.roleId);
                // this.$store.dispatch("setRoutes", response.menus).then((_) => {
                //
                // });
                if (response.menus && response.menus.length > 0) {
                  if (
                    response.menus[0].children &&
                    response.menus[0].children.length > 0
                  ) {
                    this.$router.replace({
                      path: response.menus[0].children[0].menuLink,
                    });
                  } else {
                    this.$router.replace({
                      path: response.menus[0].menuLink,
                    });
                  }
                } else {
                  this.$message.warning('登录失败，请联系管理员配置菜单')
                }
              })
              .catch((_) => {
                this.loading = false;
              });
            this.$store.dispatch("getDicts");
          })
          .catch((_) => {
            this.loading = false;
          });
        // login(this.loginForm)
        //   .then((res) => {
        //     this.loading = false;
        //     if (res.code === 200) {
        //       localStorage.setItem("token", res.data.accessToken);
        //       localStorage.setItem("refreshToken", res.data.refreshToken);
        //       setTimeout(() => {
        //         this.getUserData();
        //         this.getAllDictData();
        //       }, 300);
        //       console.log("eeee", res.data);
        //       // this.$router.replace({
        //       //   path: "/homePage",
        //       // });
        //     } else if (res.code === 433) {
        //       this.getLoginId();
        //     }
        //   })
        //   .catch((err) => {
        //     this.loading = false;
        //   });
      });
    },
    getAllDictData() {
      getDictPageAll().then((res) => {
        if (res.code === 200) {
          localStorage.setItem("dict", JSON.stringify(res.data));
        }
      });
    },
    enterLogin() {
      document.onkeydown = (e) => {
        e = window.event || e;
        if (
          this.$route.path == "/login" &&
          (e.code == "Enter" || e.code == "enter")
        ) {
          this.login();
        }
      };
    },
    clear() {
      docCookies.clear();
      docCookies.delCookie("token", "localhost");
      docCookies.delCookie("token", "59.215.221.2");
      localStorage.clear();
    },
  },
};
</script>
<style lang="scss">
.login {
  .el-input__suffix-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  .el-input__inner {
    border: none !important;
    background-color: #fafafa !important;
  }
  .el-input__inner {
    height: 0.56rem;
    line-height: 0.56rem;
    border-radius: 0.12rem;
    padding-left: 16px;
    padding-right: 16px;
  }
  .el-input__suffix {
    right: 16px;
  }
  .el-form-item {
    margin-bottom: 0.2rem;
  }
}
</style>
<style lang="scss" scoped>
.login {
  height: 100%;
  width: 100%;
  background-image: url("~@/assets/img/login_bg.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .login-logo {
    position: fixed;
    top: 0px;
    left: 0px;
    .logo-image {
      width: 1.71rem;
      height: 0.53rem;
      margin: 0.46rem 0 0 0.46rem;
    }
  }

  .login-input {
    width: 4.49rem;
    height: auto;
    margin-left: 2.53rem;
    .login-input-txt {
      font-weight: 500;
      font-size: 0.38rem;
      color: #111827;
      line-height: 0.4rem;
      padding-bottom: 0.31rem;
    }
    .pass-image {
      width: 0.24rem;
      height: 0.24rem;
      cursor: pointer;
    }
    .code-image {
      width: 1.36rem;
      height: 0.35rem;
      border: 0.01rem solid #eeeeee;
      cursor: pointer;
    }
    .btn_login {
      width: 100%;
      height: 0.56rem;
      background: #526bec;
      border-radius: 0.14rem;
      font-weight: 600;
      font-size: 0.16rem;
      color: #ffffff;
      line-height: 0.24rem;
      text-align: center;
    }
  }
}
</style>
